import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {BarcodeState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class BarcodeQuery extends QueryEntity<BarcodeState> {

  constructor(protected store: Store) {
    super(store);
  }

}
